import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/social-instagram.svg';
import { Icon } from '../Icon/Icon';
export const SocialInstagramIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
